
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Pessac dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Pessac certifiée Google Partner, accompagne les entreprises pessacaises pour booster leur visibilité en ligne et accroître leur base de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Pessac dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Pessac certifiée Google Partner, accompagne les entreprises pessacaises pour booster leur visibilité en ligne et accroître leur base de clients.",
        },
      ],
    };
  },
};
